import React, { Children, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridDenseProductsRow = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <View style={styles.container}>
      {Children.map(children, (child) => (
        <View style={styles.cell}>{child}</View>
      ))}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CELL_GUTTER = theme.spacing['3'] / 2;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginHorizontal: -CELL_GUTTER,
    marginBottom: theme.spacing['3'],
  },
  cell: {
    width: '50%',
    paddingHorizontal: CELL_GUTTER,
  },
});
